import request from "./request.js";
// import qs from "qs";

let baseUrl = "";

if (process.env.NODE_ENV == "development") {
  baseUrl = "api/";
} else {
  baseUrl = "";
}
//登录
export function login(params) {
  return request({
    url: baseUrl + "/api/v1/Login",
    method: "post",
    data: params
  });
}

// 邮箱注册验证码
export function registryCode(params) {
  return request({
    url: baseUrl + "api/v1/RegistrationCode",
    method: "post",
    data: params
  });
}
//验证是否注册
export function registered(params) {
  return request({
    url: baseUrl + "api/v1/Registered",
    method: "post",
    data: params
  });
}

//注册
export function registry(params) {
  return request({
    url: baseUrl + "/api/v1/Registry",
    method: "post",
    data: params
  });
}

//忘记密码-邮箱验证码获取
export function forgotPasswordCode(params) {
  return request({
    url: baseUrl + "/api/v1/ForgotPasswordCode",
    method: "post",
    data: params
  });
}

//忘记密码-邮箱
export function forgotPassword(params) {
  return request({
    url: baseUrl + "/api/v1/ForgotPassword",
    method: "post",
    data: params
  });
}

// 账户信息查询
export function accounts(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id,
    method: "get"
  });
}

// 个人信息查询
export function users(params) {
  return request({
    url: baseUrl + "/api/v1/Users/" + params.id,
    method: "get"
  });
}

// 个人信息修改
export function accountsProfile(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Profile",
    method: "post",
    data: params
  });
}

// 用户签到
export function accountsToday(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Today",
    method: "post"
  });
}

// 用户是否签到
export function accountsTodayStatus(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/TodayStatus",
    method: "get"
  });
}

// 答题历史
export function accountsHistoricalSurveys(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/HistoricalSurveys",
    method: "get",
    params: params
  });
}

// 金币历史
export function accountsPoints(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Points",
    method: "get",
    params: params
  });
}

// 信用值历史
export function accountsCredits(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Credits",
    method: "get",
    params: params
  });
}

// 头像修改
export function accountsAvatar(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Avatar",
    method: "post",
    data: params
  });
}

// 头像上传 Post /api/v1/AvatarUrl
export function avatarUrl(params) {
  return request({
    url: baseUrl + "/api/v1/AvatarUrl",
    method: "post",
    data: params
  });
}

// 修改Paypal Post
export function accountsAlipay(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Alipay",
    method: "post",
    data: params
  });
}

// 修改Paypal Post
export function accountsPaypal(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Paypal",
    method: "post",
    data: params
  });
}

// 密码修改
export function accountsChangePassword(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/ChangePassword",
    method: "post",
    data: params
  });
}

// 用户签到情况
export function accountsCheckinDays(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/CheckinDays",
    method: "get",
    params: params
  });
}

// 省份 Get /api/v1/Provinces
export function Provinces(params) {
  return request({
    url: baseUrl + "/api/v1/Provinces",
    method: "get"
  });
}

// 省份对应城市 Get /api/v1/Provinces/{id}/Cities
export function Cities(params) {
  return request({
    url: baseUrl + "/api/v1/Provinces" + params.id + "/Cities",
    method: "get"
  });
}

// 城市对应区县 Get /api/v1/Cities/{id}/Districts
export function Districts(params) {
  return request({
    url: baseUrl + "/api/v1/Cities" + params.id + "/Districts",
    method: "get"
  });
}

// 阿里省份 Get /api/v1/AliProvinces
export function AliProvinces(params) {
  return request({
    url: baseUrl + "/api/v1/AliProvinces",
    method: "get"
  });
}

// 阿里城市 Get /api/v1/AliCities
export function AliCities(params) {
  return request({
    url: baseUrl + "/api/v1/AliCities",
    method: "get"
  });
}

// 阿里省份对应城市 Get /api/v1/AliProvinces/{id}/AliCities
export function AliProvincesAliCities(params) {
  return request({
    url: baseUrl + "/api/v1/AliProvinces" + params.id + "/AliCities",
    method: "get"
  });
}

// 国家（地区） Get /api/v1/Countries
export function Countries(params) {
  return request({
    url: baseUrl + "/api/v1/Countries",
    method: "get"
  });
}

// 城市 Get /api/v1/Cities
export function CitiesInfo(params) {
  return request({
    url: baseUrl + "/api/v1/Cities",
    method: "get"
  });
}

// IP所在地检查 Post /api/v1/IP
export function IP(params) {
  return request({
    url: baseUrl + "/api/v1/IP",
    method: "post"
  });
}

/* 问卷 */

// 推荐问卷 IndividualSurveys
export function IndividualSurveys(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/IndividualSurveys",
    method: "get"
  });
}

// 在线讨论api/v1/Accounts/{id}/SurveysOfCint
export function SurveysOfCint(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/SurveysOfCint",
    method: "get"
  });
}
// 幸运问卷 SurveysOfLucid SurveysOfYours
// api/v1/Accounts/{id}/SurveysOfLucid
// api/v1/Accounts/{id}/SurveysOfYours
export function SurveysOfLucid(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/SurveysOfLucid",
    method: "get"
  });
}

export function SurveysOfYours(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/SurveysOfYours",
    method: "get"
  });
}

// 问卷信息查询 Get /api/v1/Surveys/{id}
export function surveys(params) {
  return request({
    url: baseUrl + "/api/v1/Surveys/" + params.id,
    method: "get"
  });
}

// weopinions图片验证码 Get /api/v1/SecurityCode
export function SecurityCode(params) {
  return request({
    url: baseUrl + "/api/v1/SecurityCode",
    method: "get"
  });
}

// 极验验证码 Get /api/v1/GeetestCode
export function GeetestCode(params) {
  return request({
    url: baseUrl + "/api/v1/GeetestCode",
    method: "get"
  });
}

/* 兑换 */
// 礼品分页列表 Get /api/v1/Gifts
export function Gifts(params) {
  return request({
    url: baseUrl + "/api/v1/Gifts",
    method: "get",
    params: params
  });
}

// 礼品详细资料 Get /api/v1/Gift/{id}
export function GiftsDetail(params) {
  return request({
    url: baseUrl + "/api/v1/Gifts/" + params.id,
    method: "get"
  });
}

// 订单分页列表 Get /api/v1/Accounts/{id}/Orders
export function Orders(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Orders",
    method: "get",
    params: params
  });
}

// 兑换礼品 Post /api/v1/Order
export function handleOrder(params) {
  return request({
    url: baseUrl + "/api/v1/Order",
    method: "post",
    data: params
  });
}

// 订单详细资料 Get /api/v1/Orders/{id}
export function OrdersDetail(params) {
  return request({
    url: baseUrl + "/api/v1/Orders/" + params.id,
    method: "get"
  });
}

/* 帮赚 */
// 推荐排行 Get /api/v1/Ranking
export function Ranking(params) {
  return request({
    url: baseUrl + "/api/v1/Ranking",
    method: "get"
  });
}

// 推荐好友分页列表 Get /api/v1/Accounts/{id}/Friends
export function AccountsFriends(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Friends",
    params,
    method: "get"
  });
}

// 推荐好友统计 Get /api/v1/Accounts/{id}/Recommend
export function AccountsRecommend(params) {
  return request({
    url: baseUrl + "/api/v1/Accounts/" + params.id + "/Recommend",
    method: "get"
  });
}
//联系我们中的提交
export function Feedback(params) {
  return request({
    url: baseUrl + "api/v1/Feedback",
    method: "post",
    data: params
  });
}


//获取ip地址
export function getIPCode(params) {
  return request({
    url: baseUrl + "api/v1/IP2",
    method: "get",
    data: params
  });
}


// WEBPACK FOOTER //
// ./src/api/api.js